import { faEdit, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { useNavigate } from 'react-router-dom';
import { Avatar, CircularProgress, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomButton from 'app/customComponents/CustomButton/CustomButton';
import { getschooldetail } from 'app/services/Company/companyService';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Company.css';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import ChangeSchoolManagerModal from '@shared/components/school/ChangeSchoolManagerModal';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		display: 'flex',
		position: 'fixed',
		width: '100%',
		height: '100%',
		flex: '1 1 auto',
	},
}));

const SchoolDetail = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(true);
	const [loaded, setIsLoaded] = useState(false);
	const [row, setrow] = useState({});
	const { id } = useParams();
	const inputRef = useRef(null);
	const [preview, setPreview] = useState(null);
	const navigate = useNavigate();
	useEffect(() => {
		let isMounted = true;
		loadSchoolDetails();
		return () => {
			isMounted = false;
		};
	}, []);

	const loadSchoolDetails = async () => {
		setIsLoading(true);
		return getschooldetail(id)
			.then((res) => {
				setrow(res?.data);
				setPreview(res?.data?.logo);
				setIsLoaded(true);
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
				console.error('data is invalid', error);
			});
	};

	const goToEditSchool = () => {
		navigate(`/EditSchool/${id}`);
	};

	const openSwitchSchoolManager = () => {
		dispatch(
			Actions.openDialog({
				children: <ChangeSchoolManagerModal school_id={row?.id} onSaved={loadSchoolDetails} />,
			})
		);
	};

	return (
		<FuseScrollbars className={classes.content} scrollToTopOnRouteChange>
			<div className="m-32" style={{ scrollBehavior: 'auto' }}>
				<div className=" flex justify-between ">
					<div className="flex gap-10">
						<span className="">
							<IconButton
								onClick={() => {
									navigate(-1);
								}}
							>
								<img
									alt="filter"
									className="backBtn-img"
									src="assets/images/arrow-long.png"
									width="24px"
								/>
							</IconButton>
						</span>
						<h2 className="font-bold">School Detail</h2>
					</div>

					<div className="personal-button flex justify-between">
						{loaded ? (
							<span className="mx-4 ">
								<CustomButton
									fontSize="15px"
									height="46"
									onClick={openSwitchSchoolManager}
									variant="secondary"
									width="180px"
								>
									<FontAwesomeIcon icon={faUserTie} />
									<span> Change Manager </span>
								</CustomButton>
							</span>
						) : null}
						<span className="mx-4 ">
							<CustomButton
								fontSize="15px"
								height="46"
								onClick={goToEditSchool}
								variant="secondary"
								width="100px"
							>
								<FontAwesomeIcon icon={faEdit} />
								<span> Edit </span>
							</CustomButton>
						</span>
					</div>
				</div>

				<div className="bg-white rounded mt-28 p-32" style={{ marginBottom: 100 }}>
					<h2 className="font-bold" style={{ fontSize: '18px' }}>
						School Manager Info
					</h2>
					<div className="flex gap-x-52 mt-12">
						{!isLoading ? (
							<div
								// onClick={() => inputRef.current.click()}
								className="row-span-2 camera-holder"
								style={{ justifySelf: 'center' }}
							>
								<Avatar src={preview} style={{ width: 120, height: 120 }} />
								{/* <div className="company-pp-overlay">
								<i className="fa fa-2x fa-camera" />
							</div> */}
								<input
									// onChange={onSelectFile}
									className="hidden"
									id="image"
									name="file"
									ref={inputRef}
									type="file"
								/>
							</div>
						) : null}
						<div className="border-bottom w-full">
							<div className="top-detail">
								<div className="flex-shrink-0 " style={{ marginBottom: '20px' }} />
								{isLoading ? (
									<CircularProgress className="m-auto justtify-center items-center flex" />
								) : (
									<div
										className="grid grid-cols-3 flex-grow"
										style={{ gap: '40px', marginRight: '6.4rem' }}
									>
										<div className="">
											<div style={{ fontSize: 14 }}>First Name</div>
											<div
												className="font-bold turncate break capitalize"
												style={{ fontSize: 16 }}
											>
												{row.primary_admins[0]?.first_name}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Last Name </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.primary_admins[0]?.last_name}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Email Address</div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.primary_admins[0]?.email}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Contact Number </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.primary_admins[0]?.phone}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Designation </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.primary_admins[0]?.designation}
											</div>
										</div>
									</div>
								)}
							</div>

							<div className="top-detail " style={{ paddingTop: '61px' }}>
								<div className="flex-shrink-0 " style={{ marginBottom: '20px' }}>
									<span className="totalRooms-heading font-bold">School Info</span>
								</div>
								{isLoading ? (
									<CircularProgress className="m-auto justtify-center items-center flex" />
								) : (
									<div
										className="grid grid-cols-3 flex-grow"
										style={{ gap: '40px', marginRight: '6.4rem' }}
									>
										<div className="">
											<div style={{ fontSize: 14 }}>Organization id</div>
											<div
												className="font-bold turncate break capitalize"
												style={{ fontSize: 16 }}
											>
												{row.otp}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>School name </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.name}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Contact Number </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.phone}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Address 1</div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.address}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Address 2</div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.street}
											</div>
										</div>

										<div className="">
											<div style={{ fontSize: 14 }}>Country </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.country.code}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>State </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.state.name}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>City </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.city}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Zip code </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.zip_code}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Status </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.status ? 'Active' : 'Inactive'}
											</div>
										</div>
										<div className="">
											<div style={{ fontSize: 14 }}>Camera Service </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.camera_service || 'Not configured'}
											</div>
										</div>
										<div />
										{row.camera_service === 'salient' && row.camera_service_settings?.config && (
											<>
												<div className="col-span-3">
													<div style={{ fontSize: 14 }}>Camera Service Settings (Salient)</div>
													<div className="grid grid-cols-3 gap-16 mt-8">
														<div>
															<div style={{ fontSize: 12, color: '#666' }}>IP Address</div>
															<div className="font-bold" style={{ fontSize: 14 }}>
																{row.camera_service_settings.config.ip_address || 'Not configured'}
															</div>
														</div>
														<div>
															<div style={{ fontSize: 12, color: '#666' }}>Username</div>
															<div className="font-bold" style={{ fontSize: 14 }}>
																{row.camera_service_settings.config.username || 'Not configured'}
															</div>
														</div>
														<div>
															<div style={{ fontSize: 12, color: '#666' }}>Password</div>
															<div className="font-bold" style={{ fontSize: 14 }}>
																{row.camera_service_settings.config.password ? '••••••••' : 'Not configured'}
															</div>
														</div>
													</div>
												</div>
											</>
										)}
										<div className="col-span-3">
											<div style={{ fontSize: 14 }}>IP Filtering </div>
											<div className="font-bold turncate break" style={{ fontSize: 16 }}>
												{row.ip_restriction ? 'Enabled' : 'Disabled'}
											</div>
											<ul className="list-inside list-disc">
												{row.ip_restriction
													? row.ip_ranges?.map((ip) => {
															return ip.start === ip.end ? (
																<li>{ip.start}</li>
															) : (
																<li>{ip.start + ' - ' + ip.end}</li>
															);
														})
													: null}
											</ul>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</FuseScrollbars>
	);
};

export default SchoolDetail;
